/*
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-05-06 15:15:39
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-08-20 19:03:35
 */
import Vue from 'vue'
import Vuex from 'vuex'
import user from '@/store/modules/user';
import partner from '@/store/modules/partner';
import custom from '@/store/modules/custom';
import getters from './getters';
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user: user,
    partner: partner,
    custom:custom
  },
  getters
})

export default store

